import renderSectionFromResponse from '../utils/render-section-from-response.js';
import dispatchEvent from '../utils/dispatch-event.js';
import updateBagCount from '../utils/update-bag-count.js';

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.sectionURL = '/cart?sections=cart-drawer';
    this.registerEventListeners();
  }

  renderCart() {
    fetch(this.sectionURL)
      .then(response => response.json())
      .then(response => {
        renderSectionFromResponse(
          '[data-cart-drawer]',
          'cart-drawer',
          response
        );

        setTimeout(() => {
          dispatchEvent('cart:rerendered', document);
        }, 500);
      });
  }

  registerEventListeners() {
    document.addEventListener('cart:quantity-updated', () => {
      this.renderCart();
      updateBagCount();
    });
  }
}

customElements.define('cart-drawer', CartDrawer);
